module.exports = __webpack_public_path__ + "img/bingo_ball-56.004f1b52.png";